import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterState } from "./type";

const initialState: FilterState = {
  filters: {
    search: "",
    status: "",
    order: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const regionalSubstitutionFilterSlice = createSlice({
  name: "regionalSubstitutionFilter",
  initialState,
  reducers: {
    updateFilter(
      state,
      action: PayloadAction<{ key: string; value: unknown }>,
    ) {
      const { key, value } = action.payload;

      if (key === "meta") {
        state.filters.meta = { ...state.filters.meta, ...(value as object) };
        return;
      }

      (state.filters as Record<string, unknown>)[key] = value;
      state.filters.meta = { ...state.filters.meta, page: 1 };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { updateFilter, resetFilters } =
  regionalSubstitutionFilterSlice.actions;
export default regionalSubstitutionFilterSlice.reducer;
export const rawRegionalSubstitutionFilterReducer =
  regionalSubstitutionFilterSlice.reducer;
